$().ready(function () {
  
$('.sizebox').on('input',function(){
  var lgt = $("#lgt").val(),wdt = $("#wdt").val(),grt = $('#surfacetype').val(), hdn = $('#showhide').val();
  var dpt;
  var lbl;
  if(grt == "Grass"){dpt = 0.08;}
  if(grt == "Gravel" || grt == "Tarmac" || grt == 'Concrete' || grt == 'Resin' || grt == "Block Paving"){dpt = 0.15;}
  if(grt == 'Patio'){dpt = 0.05;}

  var dty;
  if(hdn == '1'){dty = 1510; lbl = 'Type 1 MOT';}
  if(hdn == '2'){dty = 1620; lbl = 'Type 2 MOT';}
  if(hdn == '3'){dty = 1600; lbl = 'Type 3 MOT';}

  console.log(lgt+'m x '+wdt+'m x '+dpt+'m at '+dty+' density');
  var total = lgt*wdt*dty*dpt
  $('#flush').html(total.toFixed(2));
  $('#filltype').html(grt);
  $('#stonetype').html(lbl);
  console.log(total);
})
});
